



















































































































import { onMounted, ref, Ref } from "@vue/composition-api";
import Vue from "vue";
import AppCheckbox from "./AppCheckbox.vue";
export default Vue.extend({
  components: { AppCheckbox },
  name: "app-details-cmp",
  props: {
    items: {
      type: Array,
    },
    rootHandler: {
      type: Function,
    },
    checkHandler: {
      type: Function,
    },
    multi: {
      type: Boolean,
      default: false,
    },
    display_count: {
      type: Boolean,
      default: false,
    },
    open_by_default: {
      type: Boolean,
      default: false,
    },
    inheritance: {
      type: Boolean,
      default: false,
    },
    checked_ids: {
      type: Object,
      default() {
        return {};
      },
    },
    done_ids: {
      type: Object,
      default() {
        return {};
      },
    },
    extras_cmp: {
      type: Function,
    },
    disable_ids: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  setup(props) {
    const current_checked_ids: Ref<Record<string, boolean>> = ref({});

    onMounted(() => {
      // @ts-ignore
      current_checked_ids.value = { ...(props.checked_ids || {}) };
    });

    const check_change = (id: string, is_checked: boolean) => {
      if (props.checkHandler) {
        //@ts-ignore
        props.checkHandler(id, is_checked);
      } else {
        if (!props.multi) {
          current_checked_ids.value = Object.entries(
            current_checked_ids.value
          ).reduce((acc, [key]) => {
            acc[key] = false;
            return acc;
          }, {} as Record<string, boolean>);
        }
        /*  if(props.inheritance){
          if()
        }else{ */
        current_checked_ids.value = {
          ...current_checked_ids.value,
          [id]: is_checked,
        };
        //  }
        //@ts-ignore
        props.rootHandler && props.rootHandler(current_checked_ids.value);
      }
    };
    return { current_checked_ids, check_change };
  },
});
